var map = {
	"./de.json": "./utils/form/errors/de.json",
	"./en.json": "./utils/form/errors/en.json",
	"./es.json": "./utils/form/errors/es.json",
	"./fr.json": "./utils/form/errors/fr.json",
	"./it.json": "./utils/form/errors/it.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./utils/form/errors sync recursive ^\\.\\/.*\\.json$";